// extracted by mini-css-extract-plugin
export default {"postIconBlk":"PostInterActionStyles_postIconBlk__MMnJb"};